module.exports = __webpack_public_path__ + "img/lionhearter.9341819d.png";